/* =========================================================
   Charm-Cart-Cleanup
   Entfernt verwaiste Charm-Positionen aus dem Warenkorb:
   Wird eine Kette gelöscht, fliegen ihre Charms (gleiche _build-ID,
   aber ohne zugehörige Kette) automatisch mit raus.
   Verhindert das "maximale Menge bereits im Warenkorb"-Problem.
   ========================================================= */
(function () {
  if (window.__charmCleanupInit) return;
  window.__charmCleanupInit = true;

  var busy = false;

  function isCartPage() {
    return /\/cart(\/|$|\?)/.test(window.location.pathname + window.location.search);
  }

  function htmlFrom(str, selector) {
    return new DOMParser().parseFromString(str, 'text/html').querySelector(selector);
  }

  async function cleanup() {
    if (busy) return;

    var cart;
    try {
      cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) {
        return r.json();
      });
    } catch (e) {
      return;
    }
    if (!cart || !cart.items || !cart.items.length) return;

    // Welche Ketten (Build-IDs) liegen aktuell im Warenkorb?
    var necklaces = {};
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._build && p['Charm-Reihenfolge']) necklaces[p._build] = true;
    });

    // Charms, deren Kette fehlt -> entfernen (Menge 0)
    var updates = {};
    var found = false;
    cart.items.forEach(function (it) {
      var p = it.properties || {};
      if (p._bundle && p._build && !necklaces[p._build]) {
        updates[it.key] = 0;
        found = true;
      }
    });
    if (!found) return;

    busy = true;
    try {
      var res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname,
        }),
      }).then(function (r) {
        return r.json();
      });

      // Warenkorb-Seite: am einfachsten frisch laden
      if (isCartPage()) {
        window.location.reload();
        return;
      }

      // Drawer-Vorschau aktualisieren (ohne ihn aufzuploppen)
      if (res && res.sections) {
        var freshDrawer = res.sections['cart-drawer'] && htmlFrom(res.sections['cart-drawer'], '#CartDrawer');
        var curDrawer = document.querySelector('#CartDrawer');
        if (freshDrawer && curDrawer) curDrawer.innerHTML = freshDrawer.innerHTML;

        var freshBubble =
          res.sections['cart-icon-bubble'] && htmlFrom(res.sections['cart-icon-bubble'], '.shopify-section');
        var curBubble = document.getElementById('cart-icon-bubble');
        if (freshBubble && curBubble) curBubble.innerHTML = freshBubble.innerHTML;

        var cd = document.querySelector('cart-drawer');
        if (cd) cd.classList.toggle('is-empty', res.item_count === 0);
      }
    } catch (e) {
      /* still ok – Geister-Charms sind serverseitig bereits entfernt */
    } finally {
      busy = false;
    }
  }

  // 1) Beim Seitenaufbau (räumt Reste aus früheren Sitzungen)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanup);
  } else {
    cleanup();
  }

  // 2) Bei jeder Warenkorb-Änderung (z. B. Kette im Drawer gelöscht)
  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, cleanup);
    }
  } catch (e) {
    /* pub/sub nicht verfügbar – Punkt 1 greift trotzdem */
  }
})();
